import React, { useCallback, useEffect, useRef, useState } from 'react'
import { LuUpload } from "react-icons/lu";
import { useForm, Controller } from 'react-hook-form';
import Select from 'react-select';

import { useGetDestinationQuery, useGetTagsQuery } from '../../../../services/Api';

import { climateOption, packingListOption, techOption, regionOptions, countryOptions, toiltryListOption, validate } from './utils';
import { BASE_URL_IMAGE } from '../../../../services/ApiEndpoints';
// import Cropper from "react-cropper";
import Cropper from 'react-easy-crop'
import { getCroppedImg } from '../../../../utils/helpers';
const AddPackingListStep1 = ({ onNext, data, imagePreview, setImagePreview, videoPreview, setVideoPreview, editPacking, creatorImagePreview, setCreatorImagePreview }) => {
    const { data: dataTag, isLoading: tagLoading } = useGetTagsQuery()
    const getTags = dataTag?.data
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [minZoom, setMinZoom] = useState(1);

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const [state, setState] = useState({
        imageFile: null,
        creatorImageFile: null,
        showMulti: false,
        selectedOptions: [],
        zoomValue: 1,
        isModalOpen: false,
        videoFile: null
    });

    const updateState = (key, value) => {
        setState((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        reset,
        watch,
        setValue, setError, clearErrors
    } = useForm({
        mode: "onTouched",
        // defaultValues: data?.data
    });
    const selectedType = watch("type"); // Watching the type field
    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            updateState("imageFile", file)
            updateState("isModalOpen", true)
        }

    };
    const handleCreatorImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            updateState("creatorImageFile", file)
            updateState("isModalOpen", true)
        }

    };
    // const handleVideoChange = (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         setValue('video', file);
    //         setVideoPreview(URL.createObjectURL(file)); // Generate a preview URL for the video
    //         updateState("videoFile", file)
    //     }
    // };
    const description = watch("description", "");

    const handleCrop = async () => {
        try {
            if (!croppedAreaPixels) {
                throw new Error("Crop area is not set properly.");
            }
            const imageSrc = state?.creatorImageFile
                ? URL.createObjectURL(state.creatorImageFile)
                : URL.createObjectURL(state.imageFile);

            const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
            URL.revokeObjectURL(imageSrc);

            if (!croppedImage) {
                throw new Error("Failed to process cropped image.");
            }

            const file = new File([croppedImage], "cropped-image.png", { type: "image/png" });
            if (state?.creatorImageFile != null) {
                setValue("creatorImage", file);
                setCreatorImagePreview(URL.createObjectURL(file));
                updateState("creatorImageFile", null);
            } else {
                setValue("thumbnail", file); // Store in form
                setImagePreview(URL.createObjectURL(file)); // Show preview
                updateState("imageFile", null);
            }

            updateState("isModalOpen", false); // Close modal
        } catch (error) {
            console.error("Error during cropping:", error.message);
            alert(error.message); // Show error message to user
        }
    };



    const optionsTags = getTags?.map((item) => ({
        value: item._id,
        label: item.name,
    }));
    const onSubmit = (data) => {
        onNext({ data },
            // true,
            validate({ data, setError, imagePreview, creatorImagePreview, imageFile: state?.imageFile, creatorImageFile: state?.creatorImageFile })
        );
    };

    useEffect(() => {
        if (data?.data) {
            reset(data?.data);
            updateState("selectedOptions", data?.data?.destinations);

            // Handle thumbnail image
            if (data?.data?.thumbnail) {
                if (typeof data?.data.thumbnail === "string") {
                    setImagePreview(`${BASE_URL_IMAGE}${data?.data?.thumbnail}`);
                } else if (data?.data.thumbnail instanceof File || data?.data?.thumbnail instanceof Blob) {
                    setImagePreview(URL.createObjectURL(data?.data?.thumbnail));
                }
            }
            if (data?.data?.creatorImage) {
                if (typeof data?.data?.creatorImage === "string") {
                    setCreatorImagePreview(`${BASE_URL_IMAGE}${data?.data?.creatorImage}`);
                } else if (data?.data?.creatorImage instanceof File || data?.data?.creatorImage instanceof Blob) {
                    setCreatorImagePreview(URL.createObjectURL(data?.data?.creatorImage));
                }
            }

            if (data?.data?.video) {
                if (typeof data?.data?.video === "string") {
                    setVideoPreview(`${BASE_URL_IMAGE}${data?.data?.video}`);
                } else if (data?.data?.video instanceof File || data?.data?.video instanceof Blob) {
                    setVideoPreview(URL.createObjectURL(data?.data?.video));
                }
            }

            // Set selected tags
            const selectedTagIds = editPacking ? data?.data?.tags?.map((item) => item?._id) : data?.data?.tags;
            setValue("tags", selectedTagIds);
        }
    }, [data?.data]);

    useEffect(() => {
        if (imagePreview) {
            clearErrors("thumbnail");
        }
        if (creatorImagePreview) {
            clearErrors("creatorImage");
        }
        if (videoPreview) {
            clearErrors("video");
        }

        // Description validation: Clear error when it has a value
        if (description?.trim()) {
            clearErrors("description");
        }
    }, [imagePreview, creatorImagePreview, videoPreview, description]);

    useEffect(() => {
        if (state?.showMulti) {
            updateState("selectedOptions", []);
        }
    }, [state?.showMulti]);

    // useEffect(() => {
    //     if (selectedType === "PRO" && !state?.videoFile && !videoPreview) {
    //         setError("video", { type: "manual", message: "Video is required" });
    //     } else {
    //         setError("video", { type: "manual", message: "" });
    //     }
    // }, [selectedType, state?.videoFile, videoPreview]);


    return (
        <div className='max-w-[1000px] !mx-auto' >
            {/* <h1 className="text-black font-['Roboto_Mono'] text-2xl font-bold text-center "> Add Packing List </h1> */}
            <div className="bg-white rounded-xl p-5 mt-6"  >
                <div className=" grid md:grid-cols-3 grid-cols-1 gap-8">

                    <div className="input_div">
                        <label htmlFor="" className='text-black font-roboto-mono font-medium text-[13px]' >Title</label>
                        <input type="text" {...register("title")} placeholder='Enter Here' className='w-full border p-3 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]' />
                        {errors.title && <p className="text-red-500 text-xs mt-1">{errors.title.message}</p>}
                    </div>


                    <div className="input_div">
                        <label htmlFor="" className='text-black font-roboto-mono font-medium text-[13px]' >Creator</label>
                        <input type="text" {...register("creator")} placeholder='Enter Here' className='w-full border p-3 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]' />
                        {errors.creator && <p className="text-red-500 text-xs mt-1">{errors.creator.message}</p>}
                    </div>

                    <div className="input_div">
                        <label
                            htmlFor="creator-file-upload"
                            className="text-black font-roboto-mono font-medium text-[13px]"
                        >
                            Creator Image
                        </label>
                        <div className="relative w-full ">
                            <input
                                id="creator-file-upload"
                                type="file"
                                className="hidden"
                                {...register("creatorImage")}
                                accept="image/*"
                                onChange={handleCreatorImageChange}
                            />
                            <label
                                htmlFor="creator-file-upload"
                                className="flex items-center text-[#1F2937AB] hover:cursor-pointer justify-between w-full border p-3 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]"
                            >
                                <span>Upload</span>
                                <LuUpload className="text-gray-500 ml-2" />
                            </label>
                        </div>
                        {errors.creatorImage && <p className="text-red-500 text-xs mt-1">{errors.creatorImage.message}</p>}

                    </div>
                    <div className="input_div">
                        <label
                            htmlFor="file-upload"
                            className="text-black font-roboto-mono font-medium text-[13px]"
                        >
                            Thumbnail
                        </label>
                        <div className="relative w-full ">
                            <input
                                id="file-upload"
                                type="file"
                                className="hidden"
                                {...register("thumbnail",)}
                                accept="image/*" // Accept only image files
                                onChange={handleImageChange}
                            />


                            <label
                                htmlFor="file-upload"
                                className="flex items-center text-[#1F2937AB] hover:cursor-pointer justify-between w-full border p-3 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]"
                            >
                                <span>Upload</span>
                                <LuUpload className="text-gray-500 ml-2" />
                            </label>
                        </div>
                        {errors.thumbnail && <p className="text-red-500 text-xs mt-1">{errors.thumbnail.message}</p>}

                    </div>
                    <div>
                        {imagePreview != null && (
                            <div className="mb-4">
                                <img
                                    src={imagePreview}
                                    alt="Selected Preview"
                                    className="mt-2 w-40 h-40 object-cover border rounded-md"
                                />
                            </div>
                        )}
                    </div>
                    <div>
                        {creatorImagePreview != null && (
                            <div className="mb-4">
                                <img
                                    src={creatorImagePreview}
                                    alt="Selected Preview"
                                    className="mt-2 w-40 h-40 object-cover border rounded-md"
                                />
                            </div>
                        )}
                    </div>

                    <div className="input_div">
                        <label htmlFor="" className='text-black font-roboto-mono font-medium text-[13px]' >Type</label>
                        <select name="" {...register("type")} className='w-full border text-[#1F2937AB] px-2 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]' id="">
                            <option >Select</option>
                            <option value={`REGULAR`} >Regular</option>
                            <option value={`PRO`} >Pro</option>
                        </select>
                        {errors.type && <p className="text-red-500 text-xs mt-1">{errors.type.message}</p>}
                    </div>

                    <div className="input_div">
                        {selectedType === "PRO" && (
                            <>
                                {/* <label
                                    htmlFor="file-upload-video"
                                    className="text-black font-roboto-mono font-medium text-[13px]"
                                >
                                    Video
                                </label>
                                <div className="relative w-full ">
                                    <input
                                        id="file-upload-video"
                                        {...register("video", {
                                            // required: "Video is required",
                                            // validate: {
                                            //     size: (value) => value[0]?.size < 50 * 1024 * 1024 || "Video must be less than 50MB"
                                            // }
                                        })}
                                        accept="video/*" // Accept only video files
                                        type="file"
                                        className="hidden"
                                        onChange={handleVideoChange}
                                    />

                                    <label
                                        htmlFor="file-upload-video"
                                        className="flex items-center text-[#1F2937AB] hover:cursor-pointer justify-between w-full border p-3 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]"
                                    >
                                        <span>Upload</span>
                                        <LuUpload className="text-gray-500 ml-2" />
                                    </label>
                                </div>
                                {errors.video && <p className="text-red-500 text-xs mt-1">{errors.video.message}</p>} */}

                                <div className="input_div mt-1">
                                    <label htmlFor="" className='text-black font-roboto-mono font-medium text-[13px]' >Youtube Url</label>
                                    <input
                                        type="text"
                                        {...register("youtubeUrl", {
                                            pattern: {
                                                value: /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[\w-]+(&.*)?$/,
                                                message: "Enter a valid YouTube URL",
                                            },
                                        })}
                                        placeholder="Enter Here"
                                        className="w-full border p-3 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]"
                                    />
                                    {errors.youtubeUrl && <p className="text-red-500 text-xs mt-1">{errors.youtubeUrl.message}</p>}
                                </div>

                            </>
                        )
                        }
                    </div>
                    <div className="">
                        {(videoPreview || watch("youtubeUrl")) && (
                            <div className="mb-4">
                                {watch("youtubeUrl") && (
                                    <iframe
                                        className="mt-2 w-full h-64 border rounded-md"
                                        src={
                                            // Convert YouTube URL to embed format
                                            watch("youtubeUrl").includes("youtu.be")
                                                ? `https://www.youtube.com/embed/${watch("youtubeUrl").split("youtu.be/")[1].split(/[?&]/)[0]}`
                                                : watch("youtubeUrl").includes("watch?v=")
                                                    ? `https://www.youtube.com/embed/${watch("youtubeUrl").split("watch?v=")[1].split(/[?&]/)[0]}`
                                                    : ""
                                        }
                                        title="YouTube Preview"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    />
                                )}
                            </div>
                        )}
                    </div>
                    <div className="input_div">
                        <label htmlFor="" className='text-black font-roboto-mono font-medium text-[13px]' >Destination</label>
                        <div className="flex items-center gap-2">
                            <button className={`px-2 text-xs py-1 ${state?.showMulti ? 'bg-white border ' : 'bg-bgprimary border border-bgprimary'} text-dark font-roboto-mono font-bold rounded`} onClick={() => updateState("showMulti", false)} >Country</button>
                            <button className={`px-2 py-1 text-xs ${state?.showMulti ? 'bg-bgprimary border border-bgprimary' : 'bg-white border'} text-dark font-roboto-mono font-bold rounded`} onClick={() => updateState("showMulti", true)} >Multiple</button>
                        </div>
                        <Controller
                            name="destinations"
                            control={control}
                            defaultValue={[]} // Initialize as an empty array
                            render={({ field }) => {
                                // Transform the edit data to match the Select component format
                                const formattedEditData = state?.selectedOptions?.map((item) => ({
                                    value: state?.showMulti ? item.region : item.country[0], // Assuming country is an array with one value
                                    label: state?.showMulti ? item.region : item.country[0],
                                }));

                                return (
                                    <Select
                                        {...field}
                                        options={state?.showMulti ? regionOptions : countryOptions}
                                        isMulti
                                        isSearchable
                                        placeholder={state?.showMulti ? "Select regions" : "Select countries"}
                                        className="mt-2"
                                        classNamePrefix="react-select"
                                        value={formattedEditData} // Set transformed data for pre-filling
                                        onChange={(selected) => {
                                            const formattedData = selected.map((item) => ({
                                                region: state?.showMulti ? item.value : "",
                                                country: !state?.showMulti ? [item.value] : [], // Ensure country is an array
                                                state: "",
                                                city: "",
                                            }));
                                            updateState("selectedOptions", formattedData)
                                            field.onChange(formattedData);
                                        }}
                                    />
                                );
                            }}
                        />

                    </div>

                    <div className="input_div mt-6">
                        <label htmlFor="" className='text-black font-roboto-mono font-medium text-[13px]' >Description</label>
                        <input type="text" {...register("description", {
                            maxLength: { value: 185, message: "Cannot exceed 185 characters" }
                        })}
                            value={watch("description", "")}
                            onChange={(e) => {
                                if (e.target.value.length <= 185) {
                                    setValue("description", e.target.value);
                                }
                            }}
                            placeholder='Enter Here' className='w-full border p-3 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]' />
                        <div className="flex justify-end">  {watch("description", "").length}/185 </div>
                        {errors.description && <p className="text-red-500 text-xs mt-1">{errors.description.message}</p>}
                    </div>
                    <div className="input_div mt-6"></div>
                    <div className="input_div">
                        <label htmlFor="" className='text-black font-roboto-mono font-medium text-[13px]' >Climate</label>
                        <Controller
                            name="climate"
                            control={control}
                            defaultValue={[]} // Initialize as an empty array
                            render={({ field, fieldState }) => (
                                <div>
                                    <Select
                                        {...field}
                                        options={climateOption} // Your options should contain values like { value: 'HOT', label: 'Hot' }
                                        isMulti
                                        isSearchable
                                        placeholder="Select Climate"
                                        className="mt-2"
                                        classNamePrefix="react-select"
                                        onChange={(selected) => {
                                            // Map selected values to the desired format
                                            const updatedClimate = selected.map((item) => ({
                                                climateType: item.value,  // 'HOT', 'MILD', etc.
                                                clothingAmount: 1,         // Initial value for clothingAmount
                                            }));
                                            field.onChange(updatedClimate);  // Update the field value
                                        }}
                                        value={field.value.map((climate) =>
                                            climateOption.find((option) => option.value === climate.climateType)
                                        )}
                                    />
                                </div>
                            )}
                        />
                        {errors.climate && <p className="text-red-500 text-xs mt-1">{errors.climate.message}</p>}
                    </div>
                    <div className="input_div">
                        <label htmlFor="" className='text-black font-roboto-mono font-medium text-[13px]' >Duration</label>
                        <select name="" {...register("duration", { required: "Duration is required" })} className='w-full border text-[#1F2937AB] px-2 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]' id="">
                            <option >Select</option>
                            <option value={`3`} >3 Days</option>
                            <option value={`7`} >7 Days</option>
                            <option value={`10`} >10 Days</option>
                            <option value={`-1`} >Long Term</option>
                        </select>
                        {errors.duration && <p className="text-red-500 text-xs mt-1">{errors.duration.message}</p>}

                    </div>
                    <div className="input_div">
                        <label htmlFor="" className='text-black font-roboto-mono font-medium text-[13px]' >Body Type</label>
                        <select name="" {...register("bodyType")} className='w-full border text-[#1F2937AB] px-2 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]' id="">
                            <option >Select</option>
                            <option value={`MALE`} >Male</option>
                            <option value={`FEMALE`} >Female</option>
                            <option value={`OTHER`} >Other</option>
                        </select>
                        {errors.bodyType && <p className="text-red-500 text-xs mt-1">{errors.bodyType.message}</p>}

                    </div>
                    <div className="input_div">
                        <label htmlFor="" className='text-black font-roboto-mono font-medium text-[13px]' >Packing Style</label>
                        <select name="" {...register("packingStyle")} className='w-full border text-[#1F2937AB] px-2 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]' id="">
                            <option >Select</option>
                            {packingListOption?.map((item, index) => {
                                return (
                                    <option key={index} value={item?.value} >{item?.label}</option>
                                )
                            })}
                        </select>

                        {errors.packingStyle && <p className="text-red-500 text-xs mt-1">{errors.packingStyle.message}</p>}

                    </div>
                    <div className="input_div">
                        <label htmlFor="" className='text-black font-roboto-mono font-medium text-[13px]' >Activity Scale</label>
                        <select name=""  {...register("activityScale")} className='w-full border text-[#1F2937AB] px-2 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]' id="">
                            <option>Select</option>
                            <option value={'1'} >1 </option>
                            <option value={'2'} >2</option>
                            <option value={'3'} >3</option>
                        </select>
                        {errors.activityScale && <p className="text-red-500 text-xs mt-1">{errors.activityScale.message}</p>}

                    </div>
                    <div className="input_div">
                        <label htmlFor="" className='text-black font-roboto-mono font-medium text-[13px]' >Toiletry</label>
                        <select name="" {...register("toiletry", { required: "Toiletry is required" })} className='w-full border text-[#1F2937AB] px-2 mt-2 border-[#E1E1E1] h-[40px] rounded-md active:outline-none focus:outline-none active:border-[#D9DCB0] focus:border-[#D9DCB0]' id="">
                            <option>Select Toiletry </option>
                            {toiltryListOption?.map((item, index) => {
                                return (
                                    <option key={index} value={item?.value} >{item?.value} </option>
                                )
                            })}
                        </select>
                        {errors.toiletry && <p className="text-red-500 text-xs mt-1">{errors.toiletry.message}</p>}

                    </div>
                    <div className="input_div">
                        <label htmlFor="" className='text-black font-roboto-mono font-medium text-[13px]' >Tech</label>
                        <Controller
                            name="tech"
                            control={control}
                            defaultValue={[]} // Initialize as an empty array
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    options={techOption}
                                    isMulti
                                    isSearchable
                                    placeholder="Select Tech"
                                    className="mt-2"
                                    classNamePrefix="react-select"
                                    onChange={(selected) => field.onChange(selected.map((item) => item.value))}
                                    value={field.value.map((val) => techOption.find((option) => option.value === val)
                                    )}
                                />
                            )}
                        />
                        {errors.tech && <p className="text-red-500 text-xs mt-1">{errors.tech.message}</p>}
                    </div>
                    <div className="input_div">
                        <label htmlFor="" className='text-black font-roboto-mono font-medium text-[13px]' >Tags</label>
                        <Controller
                            name="tags"
                            control={control}
                            defaultValue={[]} // Initialize as an empty array
                            render={({ field, fieldState }) => (
                                <div>
                                    <Select
                                        {...field}
                                        options={optionsTags}
                                        isMulti
                                        isSearchable
                                        placeholder="Select Tags"
                                        className="mt-2"
                                        classNamePrefix="react-select"
                                        onChange={(selected) => {
                                            // Limit the selection to 5 tags
                                            if (selected.length <= 5) {
                                                field.onChange(selected.map((item) => item.value));
                                            } else {
                                                setError('tags', { type: 'manual', message: 'You can only select up to 5 tags' });
                                                // alert('You can only select up to 5 tags');
                                            }
                                        }}
                                        value={field.value?.map((val) =>
                                            optionsTags?.find((option) => option?.value === val)
                                        )}
                                    />
                                </div>
                            )}
                        />
                        {errors.tags && <p className="text-red-500 text-xs mt-1">{errors.tags.message}</p>}

                    </div>
                </div>
                <div className="flex justify-end mt-5">
                    {/* <Button label={`Save`} onClick={handleSubmit(onSubmit)} className='flex items-center justify-center gap-3 bg-bgprimary rounded-lg px-5 py-2 font-quicksand text-black font-semibold text-[14px]' loading={addLoading} /> */}
                    <button className='px-4 py-2 bg-bgprimary text-dark font-roboto-mono font-bold rounded '
                        onClick={handleSubmit(onSubmit)}
                        // onClick={() => alert('data')}
                        type='submit'
                    >Next </button>
                </div>
            </div>

            {state?.isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-4 rounded-lg shadow-lg w-[350px] h-[600px] relative">
                        <h2 className="text-lg font-bold mb-2">Crop Your Image</h2>
                        <div className="crop-container h-[200px]  w-full">
                            <Cropper
                                image={URL.createObjectURL(
                                    state?.creatorImageFile != null ? state.creatorImageFile : state.imageFile
                                )}
                                crop={crop}
                                zoom={zoom}
                                aspect={4 / 4}
                                onCropChange={setCrop}
                                onCropComplete={onCropComplete}

                                onZoomChange={setZoom}
                                style={{ height: "200px", width: "100%" }}
                            />
                        </div>
                        <div className="controls">
                            <input
                                type="range"
                                value={zoom}
                                min={0.5}
                                max={3}
                                step={0.1}
                                aria-labelledby="Zoom"
                                onChange={(e) => {
                                    setZoom(e.target.value)
                                }}
                                className="zoom-range"
                            />
                        </div>

                        <div className="flex justify-end space-x-2 mt-4 absolute bottom-4 left-[35%] translate-x-[-50%] w-full">
                            <button className="px-4 py-2 bg-gray-400 text-dark rounded border border-bgprimary" onClick={() => updateState("isModalOpen", false)}>
                                Cancel
                            </button>
                            <button className="px-4 py-2 bg-bgprimary text-dark font-roboto-mono font-bold rounded" onClick={handleCrop}>
                                Crop & Save
                            </button>
                        </div>




                    </div>
                </div>
            )}


        </div>
    )
}

export default AddPackingListStep1
